<template>
  <div class="voucherCode" style="align-items: center;">
    <label style="flex: 0 0 110px">
      Gutschein-Code:
    </label>
    <md-field :class="{ 'md-error': resolveFailed && joinCodeInfo == false, 'md-valid': resolvePassed || joinCodeInfo }" style="margin-left: 8px; flex: 0 1 160px;">
      <md-input :value="value || ''" @input="debouncedUpdateValue($event)" style="text-align: center;"></md-input>

      <slide-y-down-transition>
        <md-icon class="error" v-show="resolveFailed && !joinCodeInfo">close</md-icon>
      </slide-y-down-transition>
      <slide-y-down-transition>
        <md-icon class="success" v-show="resolvePassed || joinCodeInfo">done</md-icon>
      </slide-y-down-transition>
    </md-field>

    <div :class="resolvePassed ? 'text-success' : 'text-danger'" style="margin-left: 18px">
      <slide-y-down-transition>
        <span v-if="message">{{message}}</span>
      </slide-y-down-transition>
    </div>

    <div v-if="joinCodeInfo" class="join-code-info">
      <div v-if="joinCodeInfo.authorized" class="join-code-info">
        <h4>{{$t('challengePage.doYouWantToJoinThisChallenge')}}</h4>
        <md-button @click="$emit('buttonClick', 'yes')" class="md-success">{{$t('general.yes')}}</md-button>
        <md-button @click="$emit('buttonClick', 'no')">{{$t('general.no')}}</md-button>
      </div>
      <div v-if="joinCodeInfo.unauthorized" class="join-code-info">
        <md-button
            class="md-round md-warning md-sm"
            @click="redirect()"
        >
          {{$t('loginPage.login')}}
        </md-button>
        {{$t('loginPage.pleaseLoginBeforeText')}}
      </div>
    </div>
  </div>
</template>

<script>
import debounce from '@/utils/debounce';

export default {
  props: ['currency', 'value', 'voucherInfo', 'joinCodeInfo'],
  data() {
    return {
      debouncedUpdateValue: debounce(value => {
        if (value.length > 2) {
          this.$emit('input', value);
        }
      })
    }
  },
  computed: {
    message() {
      return this.voucherInfo && this.voucherInfo.message;
    },
    resolveFailed() {
      return this.value && this.voucherInfo && !this.voucherInfo.valid;
    },
    resolvePassed() {
      return this.value && this.voucherInfo && this.voucherInfo.valid;
    },
  },
  methods: {
    redirect() {
      this.$router.push('/Login')
    }
  }
};
</script>

<style lang="css" scoped>
.join-code-info {
  display: flex;
  align-items: center;
}
@media (min-width: 768px) {
  .voucherCode {
    display: flex;
  }
}
</style>
